export default "__VITE_ASSET__r5AtWU1W__"